import { UpsertCoursePackageApiDTO } from '@/jbi-shared/dto/jtms.dtos';
import { UpsertCoursePackageResponse } from '@/store/modules/jtms/course-package/course-package.types';
import { axios } from './axios';

export const coursePackageApi = {
  upsertCoursePackageApi(payload: UpsertCoursePackageApiDTO) {
    return axios.post<UpsertCoursePackageResponse>(
      `/courses/course-packages`,
      payload
    );
  },

  deleteCoursePackageApi(payload: number[]) {
    return axios.delete(`/courses/course-packages?ids=${payload.join(',')}`);
  }
};
